import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.3609 2.69028L8.97549 1.26279C9.3173 1.17588 9.67962 1.27546 9.92901 1.52485L21.8628 13.4587C22.2534 13.8492 22.2534 14.4824 21.8628 14.8729L14.7918 21.944C14.4013 22.3345 13.7681 22.3345 13.3776 21.944L1.44526 10.0117C1.19505 9.76145 1.0957 9.39763 1.18401 9.05498L2.63896 3.40987C2.73012 3.05615 3.00689 2.78029 3.3609 2.69028ZM4.01745 4.07114L2.70718 9.15311L14.0838 20.5298L20.4478 14.1658L9.06831 2.78632L4.01745 4.07114ZM6.99991 8.99989C8.10448 8.99989 8.99991 8.10446 8.99991 6.99989C8.99991 5.89532 8.10448 4.99989 6.99991 4.99989C5.89534 4.99989 4.99991 5.89532 4.99991 6.99989C4.99991 8.10446 5.89534 8.99989 6.99991 8.99989Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }